import { gql } from '@apollo/client';

const UNSKIP_ASSIGNMENT = gql`
  mutation unskipAssignment($data: AssignmentUnskipInput!) {
    unskipAssignment(data: $data) {
      id
      assignmentActivityId
      status
      dateStarted
      dateCompleted
    }
  }
`;

export default UNSKIP_ASSIGNMENT;
